import { all, fork } from "redux-saga/effects";

import * as authSaga from "./authSaga";
import * as RolesAndPermissions from "./RolesAndPermissionsSaga"
import * as dashboardSaga from "./DashboardSaga";
import * as topSectionSaga from "./TopSectionSaga";
import * as companySaga from './companySaga';
import * as employeesSaga from './EmployeesSaga';
import * as dutyTypeSaga from './DutyTypeSaga';
import * as carSaga from './CarSaga';
import * as driverSaga from './DriverSaga';
import * as vehicleSaga from "./VehicleSaga";
import * as subVendorSaga from "./SubVendorSaga";
import * as rateCardSaga from "./RateCardSaga";
import * as serviceCitySaga from "./ServiceCitySaga";
import * as settingsSaga from "./SettingsSaga";
import * as complianceSaga from "./ComplianceSaga";
import * as chooseYourService from "./ChooseYourServiceSaga";
import * as googleMap from "./GoogleMapSaga";
import * as reservation from "./reservationSaga";
import * as operations from "./OperationsSaga";

import * as vendor from "./VendorSaga";
import * as settlement from "./SettlementSaga";
import * as allot from "./AllotSaga";
import * as billing from "./BillingSaga";
import * as report from "./ReportsSaga";
import * as Logout from "./LogoutSaga"
import * as AdminUser from "./AdminUserSaga"
import * as Feedback from "./TagSaga"
import * as FAQ from "./FAQSaga"
import * as notification from "./NotificationSaga"
import * as customerComplaints from "./CustomerComplaintsSaga"
import * as customerSaga from "./CustomerSaga";
import * as CouponSaga from "./CouponSaga"; 

export default function* rootSaga() {
    yield all([
    ...Object.values(authSaga),
    ...Object.values(RolesAndPermissions),
    ...Object.values(dashboardSaga),
    ...Object.values(topSectionSaga),
    ...Object.values(companySaga),
    ...Object.values(employeesSaga),
    ...Object.values(dutyTypeSaga),
    ...Object.values(rateCardSaga),
    ...Object.values(carSaga),
    ...Object.values(driverSaga),
    ...Object.values(serviceCitySaga),
    ...Object.values(settingsSaga),
    ...Object.values(settlement),
    ...Object.values(vehicleSaga),
    ...Object.values(subVendorSaga),
    ...Object.values(complianceSaga),
    ...Object.values(chooseYourService),
    ...Object.values(reservation),
    ...Object.values(operations),
    ...Object.values(vendor),
    ...Object.values(googleMap),
    ...Object.values(allot),
    ...Object.values(billing),
    ...Object.values(report),
    ...Object.values(Logout),
    ...Object.values(AdminUser),
    ...Object.values(Feedback),
    ...Object.values(FAQ),
    ...Object.values(notification),
    ...Object.values(customerComplaints),
    ...Object.values(customerSaga),
    ...Object.values(CouponSaga),
   ].map(fork));
  }
